import { ApiParams } from "../../_params.js"
import { httpRequest, endpoint } from "@cirrus/core/http"

export const scheduleItemLockInfoGET = async (scheduleId) =>
  await httpRequest.get(endpoint.withRoot(`/api/v1/author/locking/${scheduleId}/lock-info`), {
    params: { type: ApiParams.lockTypes.scheduleSharing },
  })
